module.exports = __webpack_public_path__ + "img/icon.14785e1.svg";